import { Injectable } from "@angular/core";
import { Http, URLSearchParams, Headers } from "@angular/http";
import { BaseProvider } from "../BaseProvider";
import { } from "../../_models/index";
import {
    LoginResponseModel,
    LeadResponseModel,
    LeadFullRequestModel,
    LeadRequestModel,
    ParamIdRequestModel,
    DocumentRequestModel,
    OrderRequestModel,
} from "../../_models/index";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { GlobalService } from "../../_global/global.service";

@Injectable()
export class LeadsService extends BaseProvider {
    getLeadSnippetURL = "reports/";
    resource = "consumerleads";
    resourceLeadsSnippet = "consumerLeadsSnippet";
    resource2 = "";
    LIST_CUSTOMER = "CUSTOMER-LIST";
    API_BASE_URL: any;
    constructor(
        private http: Http,
        public _gs: GlobalService,
    ) {
        super(http);
    }
    getLeads(isBranchId) {
        if (isBranchId) {
            return this.makeGetCall(
                this.resource +
                "?partnerId=" +
                this._gs.currentUser.partner.id +
                "&branchId=" +
                this._gs.currentUser.branch.id,
            );
        } else {
            return this.makeGetCall(
                this.resource + "?partnerId=" + this._gs.currentUser.partner.id,
            );
        }
    }

    getLeadsSnippet(isBranchId) {
        if (isBranchId) {
            return this.makeGetCall(
                this.resourceLeadsSnippet +
                "?partnerId=" +
                this._gs.currentUser.partner.id +
                "&branchId=" +
                this._gs.currentUser.branch.id,
            );
        } else {
            return this.makeGetCall(
                this.resourceLeadsSnippet +
                "?partnerId=" +
                this._gs.currentUser.partner.id,
            );
        }
    }

    getLeadDocs(leadId) {
        return this.makeGetCall("doclocker/documents/" + leadId);
    }

    postLead(req) {
        return this.makePostCall("idp/cns/consumerleads", req);
    }

    bulkUPloadLead(request) {
        return this.makeUploadCall("consumerleadsbulk", request);
    }

    bulkUPloadLeadForIDP(request) {
        return this.makeUploadCall("idp/cns/consumerleadsbulk", request);
    }

    getLeadsHO(partnerId: any, branchId: any, status: any) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        if (branchId != -1 && status != -1) {
            return this.makeGetCall(
                this.resource +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&consumerLeadStatus=" +
                status,
            );
        } else if (branchId != -1) {
            return this.makeGetCall(
                this.resource + "?partnerId=" + partnerId + "&branchId=" + branchId,
            );
        } else if (status != -1) {
            return this.makeGetCall(
                this.resource +
                "?partnerId=" +
                partnerId +
                "&consumerLeadStatus=" +
                status,
            );
        } else {
            return this.makeGetCall(this.resource + "?partnerId=" + partnerId);
        }
    }

    getLeadsHOSnippet(partnerId: any, branchId: any, status: any) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        if (branchId != -1 && status != -1) {
            return this.makeGetCall(
                this.resourceLeadsSnippet +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&consumerLeadStatus=" +
                status,
            );
        } else if (branchId != -1) {
            return this.makeGetCall(
                this.resourceLeadsSnippet +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId,
            );
        } else if (status != -1) {
            return this.makeGetCall(
                this.resourceLeadsSnippet +
                "?partnerId=" +
                partnerId +
                "&consumerLeadStatus=" +
                status,
            );
        } else {
            return this.makeGetCall(
                this.resourceLeadsSnippet + "?partnerId=" + partnerId,
            );
        }
    }

    getLeadsBranch() {
        return this.makeGetCall(
            this.resource +
            "?partnerId=" +
            this._gs.currentUser.partner.id +
            "&branchId=" +
            this._gs.currentUser.branch.id,
        );
    }

    getLeadsBranchSnippet() {
        return this.makeGetCall(
            this.resourceLeadsSnippet +
            "?partnerId=" +
            this._gs.currentUser.partner.id +
            "&branchId=" +
            this._gs.currentUser.branch.id,
        );
    }

    getAllLeads() {
        // Fetch all leads given the token
        return this.makeGetCall(this.resource);
    }

    getAllLeadsSnippet() {
        // Fetch all leads given the token
        return this.makeGetCall(this.resourceLeadsSnippet);
    }
    getFilteredLeads(partnerId, status, startDate, endDate, branchId) {
        // Fetch all leads with given filters
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        if (status != -1 && branchId != -1) {
            const url: string =
                this.resourceLeadsSnippet +
                "?partnerId=" +
                partnerId +
                "&consumerLeadStatus=" +
                status +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (status != -1) {
            const url: string =
                this.resourceLeadsSnippet +
                "?partnerId=" +
                partnerId +
                "&consumerLeadStatus=" +
                status +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else if (branchId != -1) {
            const url: string =
                this.resourceLeadsSnippet +
                "?partnerId=" +
                partnerId +
                "&branchId=" +
                branchId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        } else {
            const url: string =
                this.resourceLeadsSnippet +
                "?partnerId=" +
                partnerId +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate;
            return this.makeGetCall(url);
        }
    }
    getLeadsbyPartner(partnerId) {
        // Fetch all leads by partner given the token
        return this.makeGetCall(
            this.resource + "?partnerId=" + this._gs.currentUser.partner.id,
        );
    }

    getLeadsbyPartnerSnippet(partnerId) {
        // Fetch all leads by partner given the token
        return this.makeGetCall(
            this.resourceLeadsSnippet +
            "?partnerId=" +
            this._gs.currentUser.partner.id,
        );
    }

    getLeadSnippet() {
        // Get Current Forex Rates
        return this.makeGetCall(
            this.getLeadSnippetURL +
            "leadConversion?scope=full&startDate=1970-01-01&endDate=2100-01-01",
        );
    }
    getLeadsGenerated() {
        return this.makeGetCall(
            this.getLeadSnippetURL +
            "consumerLeadsByBranchByDate?partnerId=" +
            this._gs.currentUser.partner.id +
            "&startDate=1970-01-01&endDate=2018-01-10",
        );
    }
    getLeadsbyFilter(params: URLSearchParams) {
        // Fetch all leads given the token
        return this.makeGetCall(this.resource + "/search", params);
    }
    getLeadDetailsbyId(leadId): Observable<any> {
        // Fetch a particular lead details given the id
        return this.makeGetCall(this.resource + "/" + leadId);
    }
    addLead(leadRequest: LeadResponseModel[]) {
        // Create a lead  given the lead details
        return this.makePostCall(this.resource, leadRequest);
    }
    postBulkLeads(orderRequest: any) {
        return this.makeUploadCall("consumerleadsbulk", orderRequest);
    }
    postBulkPAN(orderRequest: any) {
        return this.makeUploadCall("panBulk", orderRequest);
    }
    updateLead(lead, ReqModel) {
        // Update a lead given the updated lead details
        return this.makePatchCall(
            this.resource + "/" + lead.consumerLeadId,
            ReqModel,
        );
    }
    deleteLead(leadId) {
        // Delete an lead  given the lead id
        return this.makeDeleteCall(this.resource + "/" + leadId);
    }
    addFullLead(
        leadFullRequest: LeadFullRequestModel,
        paramId: ParamIdRequestModel,
    ) {
        this.resource2 =
            "consumers/" +
            paramId.consumerId +
            "/orders?userId=" +
            paramId.userId +
            "&partnerId=" +
            paramId.partnerId;
        return this.makePostCall(this.resource2, leadFullRequest);
    }
    uploadDocumentPost(uploadRequest: any) {
        // Upload Documents
        let docUrl = "doclocker/documents";
        return this.makeUploadCallPost(docUrl, uploadRequest);
    }
    getDocumentPost(getdRequest: LoginResponseModel) {
        let getdocUrl = "doclocker/documents/";
        return this.makeGetCall(getdocUrl + getdRequest.id);
    }
    getOrderDetail(order: OrderRequestModel): Observable<any> {
        // Fetch a particular lead details given the id
        return this.makeGetCall("orders?consumerId=" + order.consumerId);
    }

    // getUserData(){
    //     return this.getIpAddress('rates/current?partnerId=p_wsfx');
    // }

    getLeadHistory(leadId: any): Observable<any> {
        // Fetch a particular lead comment details given the id
        return this.makeGetCall(this.resource + "/" + leadId + "/comments");
    }
    getCredilaLeads(fromDate: string, toDate: string) {
        return this.makeGetCall(
            "getCredilaLeads?fromDate=" + fromDate + "&toDate=" + toDate,
        );
    }

    getLeadById(id: string) {
        return this.makeGetCall("credila/logsByIdentifier?identifier=" + id);
    }

    addNewInteraction(req: any) {
        return this.makePostCall("registerLeadInteractions", req);
    }

    getLeadInteractions(leadId: string) {
        return this.makeGetCall("getAllLeadInteractions?leadId=" + leadId);
    }

    getCredilaLeadsByStatus(status: string) {
        return this.makeGetCall(`credila/getAllByStatus?status=${status}`);
    }
    getFxcLeads() {
        return this.makeGetCall("fxc/viewAllLeads");
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/leads/leads.service.ts